/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

export type TradeInFooterLinksApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
}

export const TradeInFooterLinksSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
})

// Schema validation
type TestTradeInFooterLinksProps = ExpectTrue<
  Equal<TradeInFooterLinksApiProps, z.infer<typeof TradeInFooterLinksSchema>>
>
